import React from 'react';
import Reflux from 'reflux';
import moment from 'moment-timezone';
import { Client } from 'api';
import Tracker from 'tracker';
import EventActions from 'actions/eventActions';
import EventStore from 'stores/eventStore';
import UserStore from 'stores/userStore';
import LoadingIndicator from 'components/loadingIndicator';
import RouteError from 'components/errors/routeError';
import NotFoundError from 'components/errors/notFoundError';

const ERROR_TYPES = {
    EVENT_NOT_FOUND: 'EVENT_NOT_FOUND',
    OTHER: 'OTHER',
};

class Event extends Reflux.Component {
    constructor(props) {
        super(props);

        this.api = new Client();
        this.tracker = new Tracker();
        this.stores = [EventStore, UserStore];

        this.state = {
            loading: true,
            error: null,
            event: {},
            user: {},
        };
    }

    componentWillMount() {
        this.api.request(`/api/events/${this.props.params.eventId}`, {
            method: 'GET',
            success: (data) => {
                data.date = moment(data.date);

                if (data.start_date) {
                    data.start_date = moment(data.start_date);
                }

                if (data.end_date) {
                    data.end_date = moment(data.end_date);
                }

                this.api.request(`/api/events/${this.props.params.eventId}/leads`, {
                    success: (leads) => {
                        data.leads = leads;
                        this.setState({ loading: false, error: null, event: data }, () => {
                            EventActions.loadEvent(data);
                        });
                    },
                });
            },
            error: (xhr) => {
                if (xhr.status === 404) {
                    this.setState({ loading: false, error: ERROR_TYPES.EVENT_NOT_FOUND });
                } else {
                    this.setState({ loading: false, error: ERROR_TYPES.OTHER });
                }
            },
        });
    }

    render() {
        if (this.state.error) {
            if (this.state.error === ERROR_TYPES.EVENT_NOT_FOUND) {
                return <NotFoundError />;
            }

            return <RouteError />;
        }

        if (this.state.loading) {
            return <LoadingIndicator />;
        }

        return (
            <div className="page-container">
                <div className="page-header">
                    <h2>{this.state.event.title}</h2>
                </div>

                {React.Children.map(this.props.children, (child) => React.cloneElement(child, {
                    event: this.state.event,
                }))}
            </div>
        );
    }
}

Event.contextTypes = {
    router: React.PropTypes.object,
};

export default Event;



// WEBPACK FOOTER //
// ./app/assets/javascripts/views/event.jsx